import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LtkError',
  setup(__props) {

const retry = () => window.location.reload();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "fill-height"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "justify-center align-center fill-height" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_icon, { size: "50" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" mdi-alert-circle ", -1)
              ])),
              _: 1,
              __: [0]
            }),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mt-4" }, "登入時發生錯誤，請重試。", -1)),
            _createVNode(_component_v_btn, { onClick: retry }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("重試", -1)
              ])),
              _: 1,
              __: [1]
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})